// Modal created when a note is created as part of a regeneration
// Clears state of parent when closing

import React, { useEffect } from 'react';
import { Row, Col } from "react-grid-system";
import { Button, Modal } from "../../common"
import * as styles from './notes.module.scss'
import { useNoteDetails } from '../../../hooks';

export const NoteCopiedModal = ({
    regeneratedNoteInfo,
    setRegeneratedNoteInfo,
    handleOpenRegeneratedNote,
}: {
    regeneratedNoteInfo: any
    setRegeneratedNoteInfo: any
    handleOpenRegeneratedNote: any
}) => {
    const { getNote, note, clearNote } = useNoteDetails()
    const resetRegeneratedNote = () => setRegeneratedNoteInfo(null)

    useEffect(() => {
        // the reference to regeneratedNoteInfo may cause an issue here
        if (note && !!regeneratedNoteInfo) {
            handleOpenRegeneratedNote(note)
            clearNote();
        }
    }, [note?.Id, regeneratedNoteInfo, handleOpenRegeneratedNote])

    const getRegeneratedNoteDetails = async () => {
        if (regeneratedNoteInfo?.RegeneratedNoteId) {
            getNote(regeneratedNoteInfo?.RegeneratedNoteId)
        }
    }

    if (regeneratedNoteInfo?.RegeneratedNoteId) {
        return (
            <Modal
                title={'Note Copied'}
                closeModal={resetRegeneratedNote}
                isModalVisible={!!regeneratedNoteInfo}
            >
                <div className={styles.viewRegeneratedNote}>
                    <Row gutterWidth={20}>
                        <p>Since you completed this note with "Regenerate when completed" <strong>a copy of the Note has been created</strong> with a <strong>Reminder Due date set in {`${regeneratedNoteInfo.RegenerateDueDays}`} days.</strong></p>
                    </Row>

                    <Row gutterWidth={20}>
                        <Col xs={6}>
                            <Button
                                variant='success'
                                minWidth='100%'
                                onClick={getRegeneratedNoteDetails}
                            >
                                View New Note
                            </Button>
                        </Col>
                        <Col xs={6}>
                            <Button
                                variant="tertiary"
                                onClick={resetRegeneratedNote}
                                minWidth='100%'
                            >
                                Close
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
        )
    }

    return null
}